import { useContext, createContext } from 'react';

export const AIContext = createContext(null);

export function useAIContext() {
  return useContext(AIContext);
}
